import React, {
  useEffect,
  useState,
  useCallback, useMemo, useRef
} from 'react';
import { Column } from 'devextreme-react/data-grid';
import { Button } from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import { TextArea } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { formatMessage } from 'devextreme/localization';
import { isOne, trim } from '../../../utils/functions';
import DataGridMVP from '../../DataGridMVP';
import PopupMVP from '../../PopupMVP';
import HeaderButtonMVP from '../../HeaderButtonMVP';
import style from '../incoming.module.scss';
import PopupErrorMVP from '../../PopupErrorMVP';

import columnDataGrid from './columnDataGrid';
import columnDataM15 from './columnDataM15';
import columnDataGridConsignment from './columnDataGridConsignment';
import columnDataM4 from './columnDataM4';
import columnDataMX1 from './columnDataMX1';
import columnDataGraif from './columnDataGraif';
import columnDataAZH from './columnDataAZH';
import columnDataMX3 from './columnDataMX3';
import columnDataTranspOrder from '../columnDataTranspOrder';
import columnDataMKM from './columnDataMKM';
import columnDataProjectNum from '../columnDataProjectNum';
import columnDataSemiAttrb from '../../Shipment/columnDataSemiAttrb';

const Incoming = ({
  incomingReducer: {
    listIncoming,
    okRequest,
    loading,
    loadingData,
    okIncomingAccept,
    error,
    okUpdate,
    okList
  },
  settingsReducer: { settings },
  tabsReducer: { tabSelect },
  userReducer: {
    permissions,
    id
  },
  getIncoming,
  getIncomingReject,
  getIncomingErrorFalse,
  isUseM4,
  isUseAZH,
  modalErrorOpen,
  modalPostStockConsignmentOpen,
  modalSKZipOpen,
  plantId,
  setInitialStateIncoming,
  showTranspOrder
}) => {
  const localTemp = JSON.parse(localStorage.getItem(`dataGridIncomingConsignment${plantId}`));

  const [filterDataGrid, setFilterDataGrid] = useState({
    dateFrom: '',
    dateTo: '',
    filter: localTemp ? localTemp.searchText : ''
  });

  /** Сохранение фильтров для сравнения изменений перед запросом */
  const prevFilterDataGrid = useRef(filterDataGrid);

  const [thisDataGridInstance, setThisDataGridInstance] = useState({});
  /**
   * Переменная для определения текущего рендера списка,
   * где 0 = первый рендер или очистка фильтра
   */
  const isListMounted = useRef(0);
  const [modalData, setModalData] = useState({ visibleAccept: false, visibleReject: false });
  /** Выбор строк */
  const [dataSource, setDataSource] = useState({
    count: [0, 0, 0],
    listAccept: '',
    listReject: '',
    selectAcceptBoxId: 0,
    selectAcceptItems: [],
    selectSubmergeItems: [],
    selectAcceptDoc: '',
    selectRejectText: '',
    selectRejectItems: [],
    selectItem: true,
    itemAcceptDate: '',
    itemAcceptMh1: '',
    itemAcceptInternalPieceId: '',
    skData: {
      count: 0,
      data: {}
    }
  });

  const [headButtVisibol, setHeadButtVisibol] = useState({ display: 'none' });
  // Выбранные элементы списка
  const [selected, setSelected] = useState([]);

  /** Сохранение выбранных элементов для передачи в запрос,
   * чтобы не реагировать на каждое изменение selected */
  const prevSelectedRef = useRef(selected);

  /** Стейт обновлены ли поля для изменения ширины */
  const [isFieldsUpdate, setIsFieldUpdate] = useState(false);

  useEffect(() => {
    if (tabSelect === 1) {
      isListMounted.current = 0;
    }
  }, [tabSelect]);

  // Сохранение выбранных элементов текущей вкладки в хранилище
  useEffect(() => {
    if (tabSelect === 1) {
      window.localStorage.setItem('checkedItems', JSON.stringify(selected.map(({ pieceNumId, qcId, actualPieceId, cgId }) => ({ pieceNumId, qcId, actualPieceId, cgId }))));
    } else {
      window.localStorage.removeItem('checkedItems');
    }
  }, [selected, tabSelect]);

  // изменение переменной после получения списка
  useEffect(() => {
    if (okList) {
      isListMounted.current += 1;
    }
  }, [okList]);

  /** Проверка формы */
  const [isValid, setIsValid] = useState(1);

  /** Видимость кнопок - Отгрузка, Отмена отгрузки */
  const [visibleBtn, setVisibleBtn] = useState({
    btnIncoming: false,
    btnIncomingCancel: false
  });

  useEffect(() => {
    if (permissions.length) {
      setVisibleBtn({
        btnIncoming: permissions.indexOf('btnIncoming') !== -1,
        btnIncomingCancel: permissions.indexOf('btnIncomingCancel') !== -1
      });
    }
  }, [permissions]);

  useEffect(() => {
    if (okRequest) {
      notify(
        {
          message: formatMessage('pieceStatusChanged'),
          height: 64,
          width: 354,
          position: { at: 'top center', my: 'top center', offset: '0 48' }
        },
        'success',
        2000
      );
      thisDataGridInstance.instance.clearSelection();
      setModalData({ visibleAccept: false, visibleReject: false });
    }
  }, [okRequest, thisDataGridInstance]);

  useEffect(() => {
    prevSelectedRef.current = selected;
  }, [selected]);

  useEffect(() => {
    if (tabSelect !== 1 || id === null) return;

    const prevSelected = prevSelectedRef.current;

    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    const filtersChanged = prevFilterDataGrid.current !== filterDataGrid;

    // если фильтры изменились
    if (filtersChanged) {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: prevSelected.map(({ pieceNumId }) => pieceNumId)
      });

      return;
    }

    // если это первый рендер и фильтры пустые
    if (isListMounted.current === 0 && !isFilterActive) {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: []
      });
    }

    isListMounted.current += 1;
    prevFilterDataGrid.current = filterDataGrid;
  }, [
    tabSelect,
    id,
    filterDataGrid,
    plantId,
    getIncoming,
    thisDataGridInstance.instance
  ]);

  useEffect(() => {
    if (okUpdate === true) {
      if (id !== null) {
        getIncoming({
          ...filterDataGrid,
          plantId,
          items: selected.map(({ pieceNumId }) => pieceNumId)
        });
      }
    }
  }, [filterDataGrid, getIncoming, id, okUpdate, plantId, selected]);

  useEffect(() => {
    if (thisDataGridInstance.instance) {
      if (loadingData) {
        thisDataGridInstance.instance.beginCustomLoading('Loading...');
      } else {
        thisDataGridInstance.instance.endCustomLoading();
      }
    }
  }, [loadingData, thisDataGridInstance]);

  /** Событие на закрыть */
  const closeHeaderButtom = useCallback(() => {
    thisDataGridInstance.instance.clearSelection();
    setHeadButtVisibol({ display: 'none' });
    setSelected([]);
  }, [thisDataGridInstance.instance]);

  const dataGridOnSelection = useCallback((selectedRowsData, component, dataSourceDop) => {
    setTimeout(() => {
      if (selectedRowsData.length) {
        const temp = [0, 0, 0];
        let listAccept = '';
        let listReject = '';
        const selectSubmergeItems = [];
        const itemsAccept = [];
        const itemsReject = [];
        const rowsToDeselect = [];
        const skData = {
          count: 0,
          data: {}
        };
        selectedRowsData.forEach((item) => {
          skData.count += 1;
          skData.data[item.qcId] = {
            qcNumId: item.qcNumId,
            qcShop: item.qcShopCode,
            qcDate: item.accountingDate
          };

          if (item.onHoldFlag) {
            rowsToDeselect.push(item.pieceNumId);
            modalErrorOpen({
              message: `${formatMessage('textModal').textIncomingHoldLeft} ${item.qcId} ${formatMessage('textModal').textIncomingHoldRight}`,
              techInfo: '',
              types: 'info',
              title: formatMessage('textError').warning
            });
          } else {
            // eslint-disable-next-line no-lonely-if
            if (item.psStatusName === 'В пути') {
              temp[0] += 1;
              listAccept += `${item.cgId} ${item.actualPieceId}; `;
              selectSubmergeItems.push(item);
              itemsAccept.push(item.pieceNumId);
            } else if (item.psStatusName === 'В наличии') {
              temp[1] += 1;
              listReject += `${item.cgId} ${item.actualPieceId}; `;
              itemsReject.push(item.pieceNumId);
            } else if (item.psStatusName === 'Отгружен') {
              temp[2] += 1;
            }
          }
          if (rowsToDeselect.length) {
            component.deselectRows(rowsToDeselect);
          }
          setSelected(selectedRowsData);
        });
        setDataSource({
          ...dataSourceDop,
          listAccept,
          listReject,
          count: temp,
          selectAcceptItems: itemsAccept,
          selectRejectItems: itemsReject,
          selectSubmergeItems,
          skData
        });
        setHeadButtVisibol({ display: 'flex' });
      } else {
        window.localStorage.removeItem('checkedItems');
        setDataSource({
          ...dataSourceDop,
          count: [0, 0, 0],
          skData: {
            count: 0,
            data: {}
          }
        });
        setHeadButtVisibol({ display: 'none' });
        setSelected([]);
      }
    }, 0);
  }, [modalErrorOpen]);
  /** Поисковая строка */
  const dataGridOnOptionChanged = useCallback(({ value, name }) => {
    if (name === 'searchPanel') {
      if (!value) {
        isListMounted.current = 0;
      }
      setFilterDataGrid({ ...filterDataGrid, filter: value });
    }
  }, [filterDataGrid]);
  /** Работа с модальками */
  const onClickButtonAccept = useCallback(() => {
    // getIncomingListStocks({ plantId });
    setDataSource({
      ...dataSource,
      selectItem: true,
      selectAcceptDoc: '',
      selectRejectText: ''
    });
    if (
      isOne(
        dataSource.selectSubmergeItems,
        'plantId',
        Number(plantId)
      )
    ) {
      modalPostStockConsignmentOpen({
        plantId,
        selectSubmergeItems: dataSource.selectSubmergeItems,
        selectAcceptItems: dataSource.selectAcceptItems
      });
    } else {
      modalErrorOpen({
        message: formatMessage('textError').differentWarehousesSelected,
        techInfo: '',
        types: 'info',
        title: formatMessage('textError').warning
      });
    }
  }, [
    dataSource,
    modalErrorOpen,
    modalPostStockConsignmentOpen,
    plantId
  ]);
  const onClickButtonReject = useCallback(() => {
    setModalData({ ...modalData, visibleReject: true });
    setIsValid(1);
    setDataSource({
      ...dataSource,
      selectAcceptDoc: '',
      selectRejectText: ''
    });
  }, [dataSource, modalData]);
  const modalOnHiding = useCallback(() => {
    setModalData({ visibleAccept: false, visibleReject: false });
  }, []);

  /** Отправка на отказ */
  const sendReject = useCallback((dataSourceTemp, thisDataGridInstanceT) => {
    if (dataSourceTemp.selectRejectText !== '' && dataSourceTemp.selectRejectText !== null) {
      getIncomingReject({
        items: dataSourceTemp.selectRejectItems,
        note: dataSourceTemp.selectRejectText,
        plantId
      });
    } else {
      setIsValid(0);
    }
    // eslint-disable-next-line
  }, [plantId]);

  // Групповое скачивание СК
  const onClickButtonSK = useCallback(() => {
    modalSKZipOpen({
      data: dataSource.skData.data,
      plantId
    });
  }, [
    dataSource.skData.data,
    modalSKZipOpen,
    plantId
  ]);

  // Обновление данных
  const onClickUpdate = useCallback(() => {
    const isFilterActive = Object.values(filterDataGrid).filter(Boolean).length;
    if (isFilterActive) {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: selected.map(({ pieceNumId }) => pieceNumId)
      });
    } else {
      getIncoming({
        ...filterDataGrid,
        plantId,
        items: []
      });
    }
  }, [filterDataGrid, getIncoming, plantId, selected]);

  // Обновление данных после приемки
  useEffect(() => {
    if (okIncomingAccept) {
      onClickUpdate();
      setInitialStateIncoming();
    }
  }, [onClickUpdate, okIncomingAccept, setInitialStateIncoming]);

  /** Изменение ширины полей TODO придумать что-нибудь лаконичнее */
  useEffect(() => {
    if (listIncoming.length && localTemp && !isFieldsUpdate) {
      let fieldModify = false;
      let dataFieldsName = ['qcId', 'documentId', 'mh3'];
      dataFieldsName.forEach((fieldName) => {
        let controlField = {
          name: fieldName,
          maxLength: 0,
          index: 0
        };
        if (!localTemp.columns.filter((item) => item.dataField === fieldName)[0]?.width) {
          localTemp.columns.forEach((item, index) => item.dataField === fieldName ? controlField.index = index : null);
          listIncoming.forEach((item) => item[fieldName]?.length * 12 > controlField.maxLength ? controlField.maxLength = item[fieldName].length * 12 : null);
          if (controlField.maxLength !== 0) {
            localTemp.columns[controlField.index].width = controlField.maxLength;
            fieldModify = true;
          }
        }
      });
      if (fieldModify) {
        localStorage.setItem(`dataGridIncomingConsignment${plantId}`, JSON.stringify(localTemp));
        setIsFieldUpdate(true);
        onClickUpdate();
      }
    }
  }, [localTemp, listIncoming, isFieldsUpdate, plantId, onClickUpdate]);

  const renderColumnDataGrid = useMemo(() => (
    columnDataGrid.map(
      (item) => {
        if (item.dataField === 'widthFact' && !settings.useMC) {
          return null;
        }

        return (
          <Column dataField={item.dataField}
                  caption={formatMessage('textTable')[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
          />
        );
      }
    )
  ), [settings.useMC]);

  const renderColumnDataGridConsignment = useMemo(() => (
    columnDataGridConsignment.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnDataM15 = useMemo(() => (
    columnDataM15.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnDataM4 = useMemo(() => (
    columnDataM4.map(
      (item) => {
        if (item.dataField === 'widthFact' && !settings.useMC) {
          return null;
        }

        return (
          <Column dataField={item.dataField}
                  caption={formatMessage('textTable').consignment[item.dataField]}
                  visible={!item.notVisible}
                  allowSearch={false}
                  allowFiltering
                  cellRender={item.cellRender}
                  key={item.dataField}
                  dataType={item.dataType}
                  cssClass={item.cssClass}
          />
        );
      }
    )
  ), [settings.useMC]);

  const renderColumnDataMX1M4 = useMemo(() => (
    columnDataMX1.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').MX1M4[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnGraif = useMemo(() => (
    columnDataGraif.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnAZH = useMemo(() => (
    columnDataAZH.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').azh[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnMX3 = useMemo(() => (
    columnDataMX3.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnTranspOrder = useMemo(() => (
    columnDataTranspOrder.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnMKM = useMemo(() => (
    columnDataMKM.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable').consignment[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
        />
      )
    )
  ), []);

  const renderColumnProjectNum = useMemo(() => (
    columnDataProjectNum.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const renderColumnSemiAttrb = useMemo(() => (
    columnDataSemiAttrb.map(
      (item) => (
        <Column dataField={item.dataField}
                caption={formatMessage('textTable')[item.dataField]}
                visible={!item.notVisible}
                allowSearch={false}
                allowFiltering
                cellRender={item.cellRender}
                key={item.dataField}
                dataType={item.dataType}
                cssClass={item.cssClass}
                width={item.width ? item.width : undefined}
        />
      )
    )
  ), []);

  const isGraif = useMemo(() => plantId === '6606' || plantId === '6607' || plantId === '7238'
      || plantId === '7257' || plantId === '7258' || plantId === '7259'
      || plantId === '7260' || plantId === '7261' || plantId === '10003' || plantId === '10004' || plantId === '10005', [plantId]);

  const isMKM = useMemo(
    () => plantId === '8103' || plantId === '8124' || plantId === '8125' || plantId === '8126' || plantId === '8127' || plantId === '8138' || plantId === '8139' || plantId === '8140',
    [plantId]
  );

  const isDipos = useMemo(() => {
    if (plantId === '8141' || plantId === '8109') {
      return true;
    }
    return false;
  }, [plantId]);

  return (
    <>
      <HeaderButtonMVP headButtVisibol={headButtVisibol}>
        <Button icon="close" stylingMode="text" onClick={closeHeaderButtom} />
        <span className="span-first">{`${formatMessage('textDataGrid').selectQU}:`}</span>
        { (dataSource.count[0])
          ? (
            <>
              <span>{`“В пути” - ${dataSource.count[0]}`}</span>
              {(visibleBtn.btnIncoming)
                ? (
                  <Button text={formatMessage('textButton').placeStock}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonAccept}
                  />
                ) : ''}
            </>
          )
          : <div />}
        { (dataSource.count[1])
          ? (
            <>
              <span>{`“В наличии” - ${dataSource.count[1]}`}</span>
              {(visibleBtn.btnIncomingCancel)
                ? (
                  <Button text={formatMessage('textButton').refuseAcceptance}
                          type="default"
                          stylingMode="contained"
                          onClick={onClickButtonReject}
                  />
                ) : ''}
            </>
          )
          : <div />}
        { (dataSource.count[2])
          ? (
            <>
              <span>{`“Отгружен” - ${dataSource.count[2]}`}</span>
            </>
          )
          : <div />}
        {(dataSource.skData.count
          ? (
            <>
              <Button text={formatMessage('textButton').downloadQc}
                      type="default"
                      stylingMode="contained"
                      onClick={onClickButtonSK}
              />
            </>
          )
          : <div />)}
      </HeaderButtonMVP>
      <DataGridMVP dataSource={listIncoming}
                   onSelectionChanged={({ selectedRowsData, component }) => dataGridOnSelection(
                     selectedRowsData,
                     component,
                     dataSource
                   )}
                   dataGridOnOptionChanged={dataGridOnOptionChanged}
                   setDataGridInstance={setThisDataGridInstance}
                   filterDataGrid={filterDataGrid}
                   setFilterDataGrid={setFilterDataGrid}
                   className="incoming"
                   setStateStoringName={`dataGridIncomingConsignment${plantId}`}
                   tText={formatMessage('textPeriodAcceptance')}
                   loadingData={loadingData}
                   onClickUpdate={onClickUpdate}
                   visibleButtonUpdate
                   shrinkToolbar={headButtVisibol.display !== 'none'}
      >
        { isUseM4 ? renderColumnDataM4 : renderColumnDataGrid }

        <Column
          dataField={'pieceId'}
          caption={formatMessage('textTable').pieceId}
          allowSearch={false}
          allowFiltering
          dataType={'string'}
        />

        { isUseM4 ? renderColumnDataMX1M4 : renderColumnDataGridConsignment }
        { isUseAZH ? renderColumnAZH : renderColumnMX3 }
        { !isUseM4 && plantId === '7399' ? renderColumnDataM15 : null }
        { isGraif ? renderColumnGraif : null }
        { showTranspOrder ? renderColumnTranspOrder : null }
        { isMKM || isDipos ? renderColumnMKM : null }
        { settings.stockType ? renderColumnProjectNum : null }
        { settings.showSemiAttrb ? renderColumnSemiAttrb : null }

        <Column
            dataField={'endCustomerName'}
            caption={formatMessage('textTable').endCustomerName}
            allowSearch={false}
            allowFiltering
            dataType={'string'}
            cellRender={({ data }) => {
              return data.endCustomerName || data.customerName || '';
            }}
        />

      </DataGridMVP>
      <PopupMVP visible={modalData.visibleReject}
                onHiding={modalOnHiding}
                title={formatMessage('textModal').refusalToAccept}
      >
        <div className="formData">
          <div className={style.containing}>
            <p>{`№ : ${dataSource.listReject !== '' ? trim(trim(dataSource.listReject, ' '), ';') : ''}`}</p>
          </div>
          <div className="optionsData">
            <span className={(isValid) ? '' : style.errorText}>{formatMessage('textData').rejectionReason}</span>
            <TextArea height={80}
                      value={dataSource.selectRejectText}
                      onValueChanged={({ value }) => setDataSource({
                        ...dataSource,
                        selectRejectText: value
                      })}
                      stylingMode="outlined"
                      isValid={!!isValid}
                      onFocusIn={() => setIsValid(1)}
                      validationError={{ message: formatMessage('textError').enterRejectionReason }}
            />
          </div>
          <div className="formButton">
            <Button text={formatMessage('textButton').cancel}
                    type="default"
                    stylingMode="text"
                    onClick={modalOnHiding}
            />
            <Button type="default"
                    stylingMode="contained"
                    width={260}
                    disabled={loading}
                    onClick={() => sendReject(dataSource, thisDataGridInstance)}
            >
              <LoadIndicator className="indicator" visible={loading} />
              <span>{formatMessage('textButton').refuseAcceptance}</span>
            </Button>
          </div>
        </div>
      </PopupMVP>
      <PopupErrorMVP visible={!!error}
                     message={error.message}
                     techInfo={error.techInfo}
                     onHiding={getIncomingErrorFalse}
                     width="600"
                     types="error"
      />
    </>
  );
};

export default Incoming;
